import { useEffect, useState } from 'react';

/** Latches true once the editor is active and its media has settled. Never goes back to false. */
export const useContentReady = (active: boolean, mediaLoading: boolean, settleMs = 150): boolean => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (ready || !active || mediaLoading) return;
    const timer = setTimeout(() => setReady(true), settleMs);
    return () => clearTimeout(timer);
  }, [ready, active, mediaLoading, settleMs]);
  return ready;
};
